import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const getColor = (ratio) => {
  if (ratio >= 1.0) return '#f44336';
  if (ratio >= 0.8) return '#ff9800';
  return '#4caf50';
};

export const UsageBar = ({ current = 0, limit, label }) => {
  if (limit == null || limit === 0) {
    return (
      <Box sx={{ minWidth: 80 }}>
        {label && (
          <Typography variant="caption" color="text.secondary" display="block">
            {label}
          </Typography>
        )}
        <Typography variant="body2">{current}</Typography>
      </Box>
    );
  }

  const ratio = current / limit;
  const color = getColor(ratio);
  const percent = Math.min(ratio * 100, 100);

  return (
    <Box sx={{ minWidth: 100 }}>
      {label && (
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
      )}
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 },
        }}
      />
      <Typography variant="caption" sx={{ color }}>
        {current} / {limit}
      </Typography>
    </Box>
  );
};
